import {JsonProperty} from '@hyperloris/tyson';
import {Trade} from "../clearing/trade";
import {AccountDefinition} from "../customer/account-definition";
import {ETicketLeg} from "./e-ticket-leg";
import {DateTime} from "luxon";
import CallPut = Trade.CallPut;
import Side = Trade.Side;

export class ETicket {

  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  idDisplay: number = -1;

  @JsonProperty()
  traderUsername: string | undefined;

  @JsonProperty()
  orderDescription: string | undefined;

  @JsonProperty()
  owner: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  orderReference: string | undefined;

  @JsonProperty()
  apsGroupId: string | undefined;

  @JsonProperty()
  customerName: string | undefined;
  customerId: string | undefined;

  @JsonProperty()
  tradeIds: string[];

  @JsonProperty()
  orderIds: string[];

  @JsonProperty()
  comment: string | undefined;

  @JsonProperty()
  accountCode: string | undefined;

  @JsonProperty()
  accountTypeCode: string | undefined;

  @JsonProperty()
  reference1: string | undefined;

  @JsonProperty()
  reference2: string | undefined;

  @JsonProperty()
  reference3: string | undefined;

  @JsonProperty()
  giveUpBrokerCode: string | undefined;

  @JsonProperty()
  giveUpMessage: string | undefined;

  @JsonProperty()
  giveUpMessage2: string | undefined;

  @JsonProperty()
  giveUpMessage3: string | undefined;

  @JsonProperty()
  broker: string | undefined;

  @JsonProperty()
  giveupAccountType: string | undefined;

  @JsonProperty()
  giveUpCommission: string | undefined;

  @JsonProperty()
  executionFee: string | undefined;

  @JsonProperty()
  openClose: AccountDefinition.OpenClose | undefined;

  @JsonProperty()
  callPut: CallPut | undefined;

  @JsonProperty()
  traderName: string | undefined;

  @JsonProperty()
  moneyOwner: string | undefined;

  @JsonProperty()
  currency: string | undefined;

  @JsonProperty()
  rate: number | undefined;

  @JsonProperty()
  businessDate: DateTime;
  @JsonProperty()
  clearingDate: DateTime;

  @JsonProperty()
  customOrderReference: string | undefined;

  @JsonProperty()
  tradingEnvironment: string | undefined;

  @JsonProperty()
  tradeType: string | undefined;

  @JsonProperty()
  contractCode: string | undefined;
  contractId: string | undefined;
  @JsonProperty()
  contractUnit: string | undefined;
  @JsonProperty()
  contractVersion: string | undefined;

  @JsonProperty()
  maturity: string | undefined;

  @JsonProperty()
  strike: number | undefined;

  @JsonProperty()
  volume: number | undefined;

  @JsonProperty()
  price: number | undefined;

  @JsonProperty()
  overrideApsPrice: number = 0;

  @JsonProperty()
  apsPrice: number = 0;

  @JsonProperty()
  apsRoundPrice: number = 0;

  @JsonProperty()
  desk: string | undefined;

  @JsonProperty()
  legs: ETicketLeg[] = [];


  @JsonProperty()
  volumeBuy: number = 0;
  @JsonProperty()
  volumeSell: number = 0;

  @JsonProperty()
  volumeBuyExecuted: number = 0;
  @JsonProperty()
  volumeSellExecuted: number = 0;
  @JsonProperty()
  state: ETicket.State = ETicket.State.WAITING;

  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  volumeExecuted: number = 0;
  @JsonProperty()
  side: Side | undefined;

  @JsonProperty()
  eticket: ETicket | undefined;
}

export module ETicket {
  export enum State {
    WAITING='WAITING',
    PENDING='PENDING',
    PARTIAL_PENDING='PARTIAL_PENDING',
    ALLOCATED='ALLOCATED',
    CLAIMED='CLAIMED',
    CANCELLED='CANCELLED'
  }
}
